import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://play.google.com/store/apps/details?id=com.emtiajium.firecracker.collaborative.vocab.practice",
  target: "_blank"
}, "Vocabulary Flashcards", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:271emtiaj@gmail.com?subject=Data Deletion Request!" }, "email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "Goodbye",
        "content-id": "deletion",
        "menu-id": "deletion-menu"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "deletion"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "8",
                sizeLg: "6",
                sizeXl: "6"
              }, {
                default: _withCtx(() => [
                  (_ctx.isReady)
                    ? (_openBlock(), _createElementBlock("view", _hoisted_1, [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-padding" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_text, { class: "ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" We are sorry to say goodbye, honestly. ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-padding" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_text, { class: "ion-text-center link-container" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" We hope you enjoyed "),
                                    _hoisted_2,
                                    _createTextVNode(" and would love to have you back someday. ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!_ctx.isAuthenticated)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 0,
                                  class: "ion-justify-content-center ion-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_text, { class: "ion-text-center" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Before we delete your account, we must ensure you are not a bot behind the screen. Can you please sign in for the last time? ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isAuthenticated)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 1,
                                  class: "ion-justify-content-center ion-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, { onClick: _ctx.signIn }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Sign In ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isAuthenticated && !_ctx.isTheUserAlone())
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 2,
                                  class: "ion-justify-content-center ion-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_text, { class: "ion-text-center" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" You belong to the \"" + _toDisplayString(_ctx.cohort.name) + "\" cohort. Therefore, we will not delete any vocabularies as these are necessary to serve other members. However, you will be removed from the cohort. ", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isAuthenticated)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 3,
                                  class: "ion-justify-content-center ion-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_text, { class: "ion-text-center" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" By clicking the below button, we will initiate the deletion of all vocabularies, your flashcards, and the account detail. After the successful deletion, you will be navigated to the home page. ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isAuthenticated)
                              ? (_openBlock(), _createBlock(_component_ion_row, {
                                  key: 4,
                                  class: "ion-justify-content-center ion-padding"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, { onClick: _ctx.assertDeletion }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Delete Myself ")
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-padding" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_text, { class: "ion-text-center email-container" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" If you want us to keep the account but remove all or partial data, do not hesitate to contact the app admin via "),
                                    _hoisted_3,
                                    _createTextVNode(" with your specific deletion request. ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}